import type { ModuleCode } from '@tracker/shared';
import { useAuth } from './useAuth';

export function useModule() {
  const { isSuperAdmin, modules } = useAuth();
  return {
    has: (code: ModuleCode): boolean => isSuperAdmin || modules.includes(code),
    hasAny: (codes: ModuleCode[]): boolean =>
      isSuperAdmin || codes.some((c) => modules.includes(c)),
  };
}
